<nav class="navbar navbar-expand-lg navbar-dark bg-custom">
    <a class="navbar-brand" [routerLink]="['/linea']"><img src="assets/img/logo.png" alt="logo" title="logo"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
    <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/linea']" routerLinkActive="active">Linea</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/barra']" routerLinkActive="active">Barras</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/donut']" routerLinkActive="active">Donut</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/radar']" routerLinkActive="active">Radar</a>
            </li>
        </ul>
    </div>
</nav>